var _defs, _path, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyVaults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bc93169a-24c4-4686-9f37-c7e4f53b3d34",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "fb114c93-7c16-4540-899a-0796041629e6",
    cx: 9,
    cy: 9,
    r: 8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5ea0ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5c9fee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#559ced"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#4a97e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#3990e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2387de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#087bd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ec478bd3-5b38-4e7f-b661-11f355578bff",
    cx: 38.95,
    cy: 182.07,
    r: 9.88,
    gradientTransform: "translate(-28.71 -163.24) scale(0.94 0.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ffd70f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ffcb12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#feac19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fea11b"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-security-245") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "aacf8311-a317-400f-b613-74bd00da5ce3",
    d: "M9,.5A8.5,8.5,0,1,0,17.5,9,8.51,8.51,0,0,0,9,.5ZM9,16.34A7.34,7.34,0,1,1,16.34,9,7.34,7.34,0,0,1,9,16.34Z",
    fill: "url(#fb114c93-7c16-4540-899a-0796041629e6)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7.34,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "bd983c41-db73-40ec-a4f4-da1213fc9924",
    d: "M13.44,7.33a1.84,1.84,0,0,0,0-2.59h0L10.29,1.58a1.83,1.83,0,0,0-2.58,0h0L4.56,4.74a1.84,1.84,0,0,0,0,2.59L7.18,10a.51.51,0,0,1,.15.36v4.88a.63.63,0,0,0,.18.44l1.2,1.2a.41.41,0,0,0,.58,0l1.16-1.16h0l.68-.68a.25.25,0,0,0,0-.34l-.49-.49a.27.27,0,0,1,0-.37l.49-.49a.25.25,0,0,0,0-.34l-.49-.49a.27.27,0,0,1,0-.37l.49-.49a.25.25,0,0,0,0-.34l-.68-.69v-.25ZM9,2.35A1,1,0,0,1,9,4.42,1,1,0,1,1,9,2.35Z",
    fill: "url(#ec478bd3-5b38-4e7f-b661-11f355578bff)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad2e7e44-9bfd-4775-8bf4-8ef26a544921",
    d: "M8.18,15.3h0a.23.23,0,0,0,.38-.17v-4a.24.24,0,0,0-.11-.2h0a.22.22,0,0,0-.34.2v4A.28.28,0,0,0,8.18,15.3Z",
    fill: "#ff9300",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a996fbff-3936-4b24-b407-369336c143ba",
    x: 6.48,
    y: 5.79,
    width: 5.17,
    height: 0.61,
    rx: 0.28,
    fill: "#ff9300",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bb12d31c-3352-4a18-87dd-a169a4a8721d",
    x: 6.48,
    y: 6.78,
    width: 5.17,
    height: 0.61,
    rx: 0.28,
    fill: "#ff9300",
    opacity: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyVaults);
export default __webpack_public_path__ + "static/media/KeyVaults.9ce97ba9e5d87b82ac976aff5786a39e.svg";
export { ForwardRef as ReactComponent };